export const BAG = 'Bag';
export const VIEWING_AS = (user: string) => `Viewing as ${user}`;
export const SIGN_OUT = 'Sign out';
